if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          details: this.querySelector('details'),
          button: this.querySelector('.share-button__copy'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[role="status"]'),
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput?.value;

        this.elements.button?.addEventListener('click', () => this.copyToClipboard());
        this.elements.closeButton?.addEventListener('click', () => this.close());
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }

      close() {
        this.elements.details?.removeAttribute('open');
      }

      copyToClipboard() {
        if (!this.urlToShare) return;

        navigator.clipboard.writeText(this.urlToShare).then(() => {
          this.elements.successMessage?.classList.remove('hidden');
          this.elements.closeButton?.classList.remove('hidden');
        });
      }
    }
  );
}
